import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ChakraProvider } from './ChakraProvider';
import { AppProvider } from './context/AppContext';
import theme from './theme';
import DeviceVerification from './components/DeviceVerification';
import IdleMonitor from './pages/IdleMonitor';
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import AdminRoute from './pages/admin/AdminRoute';
import MensalistasPage from './pages/admin/MensalistasPage';
import CheckoutPage from './pages/CheckoutPage';
import BarbeirosPage from './pages/admin/BarbeirosPage';
import ServicosPage from './pages/admin/ServicosPage';
import ProductsAdminPage from './pages/admin/ProductsAdminPage';
import PacotesMensalistasAdminPage from './pages/admin/PacotesMensalistasAdminPage';
import CortesAdminPage from './pages/admin/CortesAdminPage';

// Novas páginas de administrador para o totem
import AdminLoginPage from './pages/AdminLoginPage';
import MensalistasListPage from './pages/admin/MensalistasListPage';
import SorteioPage from './pages/admin/SorteioPage';
import SorteioConfigPage from './pages/admin/SorteioConfigPage';
import AgendaPage from './pages/admin/AgendaPage';

// Importação das páginas
import SchedulePage from './pages/SchedulePage';
import GalleryPage from './pages/GalleryPage';
import ProductsPage from './pages/ProductsPage';
import FeedbackPage from './pages/FeedbackPage';
import ProfilePage from './pages/ProfilePage';
import IdlePage from './pages/IdlePage';
import MobileCheckinPage from './pages/mobile/MobileCheckinPage';
import MobileWelcomePage from './pages/mobile/MobileWelcomePage';
import AdminMobileLoginPage from './pages/mobile/AdminMobileLoginPage';
import AdminMobileSuccessPage from './pages/mobile/AdminMobileSuccessPage';
import CheckInPage from './pages/CheckInPage';
import WelcomePage from './pages/WelcomePage';
import MenuPage from './pages/MenuPage';
import BecomeMemberPage from './pages/BecomeMemberPage';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <AppProvider>
        <Router>
          <IdleMonitor />
          <DeviceVerification>
            <Routes>
            {/* Páginas ocultas para gerenciamento de mídias */}
            <Route path="/admin-midia" element={React.createElement(require('./pages/AdminMidiaPage').default)} />
            <Route path="/video-compression-help" element={React.createElement(require('./pages/VideoCompressionHelp').default)} />
            <Route path="/" element={<IdlePage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/check-in" element={<CheckInPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/feedback" element={<FeedbackPage />} />
            <Route path="/profile" element={<ProfilePage />} />

            {/* Rotas de admin */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route path="/admin/dashboard" element={
              <AdminRoute>
                <DashboardPage />
              </AdminRoute>
            } />
            <Route path="/admin/mensalistas" element={
              <AdminRoute>
                <MensalistasPage />
              </AdminRoute>
            } />
            <Route path="/admin/barbeiros" element={
              <AdminRoute>
                <BarbeirosPage />
              </AdminRoute>
            } />
            <Route path="/admin/servicos" element={
              <AdminRoute>
                <ServicosPage />
              </AdminRoute>
            } />
            <Route path="/admin/produtos" element={
              <AdminRoute>
                <ProductsAdminPage />
              </AdminRoute>
            } />
            <Route path="/admin/cortes" element={
              <AdminRoute>
                <CortesAdminPage />
              </AdminRoute>
            } />
            <Route path="/admin/pacotes" element={
              <AdminRoute>
                <PacotesMensalistasAdminPage />
              </AdminRoute>
            } />

            {/* Rotas Mobile */}
            {/* Rotas de admin do totem */}
            <Route path="/admin-login" element={<AdminLoginPage />} />
            <Route path="/admin/mensalistas" element={<MensalistasListPage />} />
            <Route path="/admin/sorteio" element={<SorteioPage />} />
            <Route path="/admin/sorteio-config" element={<AdminRoute><SorteioConfigPage /></AdminRoute>} />
            <Route path="/admin/agenda" element={<AgendaPage />} />
            
            {/* Rotas Mobile */}
            <Route path="/mobile/checkin" element={<React.Suspense fallback={null}><MobileCheckinPage /></React.Suspense>} />
            <Route path="/mobile/welcome" element={<React.Suspense fallback={null}><MobileWelcomePage /></React.Suspense>} />
            <Route path="/admin-mobile-login" element={<React.Suspense fallback={null}><AdminMobileLoginPage /></React.Suspense>} />
            <Route path="/mobile/admin-success" element={<React.Suspense fallback={null}><AdminMobileSuccessPage /></React.Suspense>} />
            <Route path="/checkout" element={<React.Suspense fallback={null}><CheckoutPage /></React.Suspense>} />
            <Route path="/become-member" element={<React.Suspense fallback={null}><BecomeMemberPage /></React.Suspense>} />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </DeviceVerification>
        </Router>
      </AppProvider>
    </ChakraProvider>
  );
}

export default App;
